/**
 * Handles global error and info messaging
 */
app.message = (function() {
    'use strict';
    var cookie = null,
        cookieName = 'myyl_alerts',
        self = {

        /**
         * Add a message to the queue
         * opts: Required. An object that contains any of the following keys:
         * opts.type: Optional. 'alert' (purple), 'info' (green), 'critical' (gray with red text), or 'error' (magenta). Default is 'alert'
         * opts.message: Required. String. The message or html that is to be displayed.
         * opts.setCookie: Optional. Boolean. If true, the ID (see next line) will be used to set the cookie so this message will not appear again
         *      until the cookie expires. Default is false.
         * opts.id: Optional. String, alphanumeric. Used to identify this message so it can't be accidentally re-added. May also be used to set a cookie (see opts.setCookie)
         *      so it will not appear again until the cookie expires.
         * opts.scroll: Optional. Boolean that makes message disappear when the page is scrolled beyond the set threshold.
         * opts.delay: Optional. Milliseconds, or 'scroll'. If numeric, a timer is set to the chosen value and the message will close after that time.
         *      If set to scoll, it sets opts.scroll to true (for legacy situations)
         * opts.callback: Optional. Function. The function to call when the message is closed.
         * opts.position: Optional. Should the message appear at the 'top' or 'bottom' of the screen. Default is 'top'.
         */
        alert: function(opts) {
            // the simplest alert can pass a string
            if (typeof opts == 'string') {
                var msg = opts;
                opts = {
                    message: msg,
                    type: 'alert'
                };
            }

            if (!opts.type) {
                opts.type = 'alert';
            }

            try {
                if (app.pws.isPreview()) {
                    // no alerts in preview mode
                    return;
                }
            } catch(err) {
                //
            }

            if (!opts.message) {
                // no alerts if the passed message is empty
                return;
            }

            // console.log(opts);

            self.loadCookie();

            // if message has already been read, do nothing
            if (opts.id) {
                // if alert is already present but not closed, don't re-add it
                if ($('[data-alert-id="'+ opts.id +'"]').length > 0) {
                    return;

                } else if (cookie) {
                    if (cookie[opts.id] == true) {
                        console.log('alert '+ opts.id +' has been read.');
                        return;
                    }
                }
            }

            var $alert;

            if (opts.type === 'alert') {
                $alert = $('<div><div class="msg">'+ opts.message +'<div class="close"></div></div></div>');

            } else {
                $alert = $('<div>'+ opts.message +'</div>');
            }

            $alert.addClass(opts.type);

            // add any data attributes or classes
            if (opts.id) {
                $alert.attr('data-alert-id', opts.id);
            }

            if (opts.scroll === true) {
                $alert.addClass('scroll-close');
                $(window).off('scroll').on('scroll', self.scrollClose);
            }

            if (opts.delay) {
                if (isNaN(parseInt(opts.delay, 10)) === false) {
                    // to handle delay when and id wasn't provided, we have to create one
                    if (!opts.id) {
                        opts.id = 'delay-'+ opts.delay;
                        $alert.attr('data-alert-id', opts.id);
                    }

                    window.setTimeout(function() {
                        $('[data-alert-id="'+ opts.id +'"]').click();
                    }, opts.delay);
                }
            }

            $('#messages div').remove();

            if (opts.type == 'alert') {
                $('#messages').append($alert).addClass('is-active');

            } else {
                $('#messages').prepend($alert).addClass('is-active');
            }

            if (opts.position == 'bottom') {
                $('#messages').addClass('bottom');
            } else {
                // in case this was set by a previous message call
                $('#messages').removeClass('bottom');
            }

            $alert.on('click', function() {
                // set a cookie value marking this as 'read' where appropriate
                if ($(this).data('alert-id') && opts.setCookie === true) {
                    self.loadCookie();
                    cookie[$(this).data('alert-id')] = true;
                    app.cookie.set(JSON.stringify(cookie), cookieName, 24); // 24 hours expiration
                }

                $(this).slideUp(150, function() {
                    $(this).remove();

                    if ($('#messages div').length < 1) {
                        $('#messages').removeClass('is-active');
                    }
                });

                if (typeof opts.callback == 'function') {
                    opts.callback();
                }
            });
        },

        /**
         * Legacy info function, passes off to alert
         */
        info: function(message, delay, callback) {
            var opts = {
                type: 'info',
                message: message,
                delay: delay,
                callback: callback
            };

            if (delay === 'scroll') {
                opts.scroll = true;

            } else {
                opts.delay = delay;
            }

            self.alert(opts);
        },

        /**
         * Legacy error function, passes off to alert
         */
        error: function(message, delay, callback) {
            var opts = {
                type: 'error',
                message: message,
                delay: delay,
                callback: callback
            };

            if (delay === 'scroll') {
                opts.scroll = true;

            } else {
                opts.delay = delay;
            }

            self.alert(opts);
        },

        loadCookie: function() {
            try {
                cookie = JSON.parse(app.cookie.get(cookieName));
            } catch(err) {
                //
            }

            if (!cookie) {
                cookie = {};
            }
        },

        /**
         * Now that messages are stacked, an id should be provided to specify which alert to clear.
         * todo: will there ever be a need to clear ALL messages?
         */
        clear: function(id) {
            if (!id) {
                return;
            }

            // close the message with the selected id
            $('[data-alert-id="'+ id +'"]').click();
        },

        /**
         * Close the messages that have the 'scroll-close' class
         */
        scrollClose: function(e) {
            if (e.currentTarget.scrollY > 300) {
                $('#messages .scroll-close').each(function() {
                    // trigger click so the attached callbacks will fire
                    $(this).click();
                });

                $(window).off('scroll', self.scrollClose);
            }
        }

    };
    return self;
})();



